import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { Language } from '../types/users'
import enTranslations from './languages/en.json'
import fiTranslations from './languages/fi.json'

export const getCurrentLanguage = (): Language => {
  const language = localStorage.getItem('language')
  return language ? (language as Language) : ('fi' as const) // use FIN by default
}

export const changeLanguageWithEvent = (event: any) => {
  const language = event.target.value
  localStorage.setItem('language', language)
  i18n.changeLanguage(language)
  // change <HTML lang=> to new language
  document.documentElement.lang = language
}

export const changeLanguage = (language: 'fi' | 'en') => {
  localStorage.setItem('language', language)
  i18n.changeLanguage(language)
  // change <HTML lang=> to new language
  document.documentElement.lang = language
}

export const getApiUrlLanguage = () => {
  const language = getCurrentLanguage()
  return `${language}-${language.toUpperCase()}`
}

// ?lang=en|fi in a link picks the language, e.g. the English catalog's apply links
const urlLanguage = new URLSearchParams(window.location.search).get('lang')
if (urlLanguage === 'en' || urlLanguage === 'fi') {
  localStorage.setItem('language', urlLanguage)
}

// get language from local storage
const lng = getCurrentLanguage()

const resources = {
  en: {
    translation: {
      ...enTranslations
    }
  },
  fi: {
    translation: {
      ...fiTranslations
    }
  }
}

i18n // eslint-disable-line
  .use(initReactI18next)
  .init({
    resources,
    lng,
    // allows ':' to work in text, otherwise cuts parts before it, ':' is used as i18n namespace separator (we don't use namespace)
    nsSeparator: false,

    fallbackLng: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true
    }
  })

export default i18n
